import axios from 'axios'
import exceptionHandler from '../exception-handler'

export default {

  settings () {
    return axios.get('/api/tracking/settings')
      .then(res => res.data)
      .catch(error => exceptionHandler.parse(error))
  }
}
